import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  PermissionSet,
  PermissionSetDetailState,
  PermissionSetState
} from './permission-sets.state'
import { selectPermissionSet } from './permission-sets.reducer'

export const selectPermissionSetState = createFeatureSelector<PermissionSetState>('permissionSet')

// Selector to get the total count of businesses
// export const selectTotalCount = createSelector(selectRoleState, (state: RoleState) => {
//   // console.log('RoleState:', state)
//   return state.totalCount
// })

// Select the feature state

// Select the feature state
export const selectPermissionSetDetailState =
  createFeatureSelector<PermissionSetDetailState>('permissionSetDetail')
export const selectPermissionSetDetail = createSelector(selectPermissionSet, state => {
  // console.log('selector state', state)
  return state || ({} as PermissionSet)
})

export const selectPermissionSetDetailError = createSelector(
  selectPermissionSetDetailState,
  (state: PermissionSetDetailState) => state.error
)

export const selectUnassignedUsers = createSelector(
  selectPermissionSetState,
  state => state.unassignedUsers
)
